<template>
  <div class="login-container">
    <div class="login-box">
      <h1 class="page-title">欢迎登录</h1>
      <h2 class="page-title1">拜谱生物百草云平台</h2>
<el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form">
    <el-form-item prop="username">
      <el-input 
        v-model="loginForm.username" 
        placeholder="请输入账号">
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input 
        v-model="loginForm.password" 
        type="password" 
        placeholder="请输入密码"
        @keyup.enter.native="handleLogin">
      </el-input>
    </el-form-item>
<!-- <el-form-item prop="code">
  <div class="captcha-wrapper">
    <el-input
      v-model="loginForm.code"
      placeholder="请输入验证码"
      class="captcha-input"
    />
    <div
      v-html="captchaSvg"
      class="captcha-image"
      @click="refreshCaptcha"
    ></div>
  </div>
</el-form-item> -->
    <el-form-item>
      <el-button type="primary" @click="handleLogin" class="login-button">登录</el-button>
    </el-form-item>
  </el-form>
      <div class="form-footer">
         <router-link to="/forget" class="footer-link">忘记密码</router-link>
        <span class="divider">|</span>
         <router-link to="/register" class="footer-link">注册账号</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
        code: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        // code: [
        //   { required: true, message: '请输入验证码', trigger: 'blur' }
        // ]
      },
      captchaSvg: '', // 存储从后端获取的 SVG 验证码
      captchaKey: '' // 存储验证码的 key，用于后续验证
    };
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            const response = await axios.post('api/login', {
              username: this.loginForm.username,
              password: this.loginForm.password,
              // captcha: this.loginForm.code
            });
            if (response.data.code == 200) {
              localStorage.setItem('token', response.data.data.token);
              localStorage.setItem('userInfo', JSON.stringify(response.data.data));
              this.$message.success('登录成功');

              // 检查用户是否为管理员
              if (response.data.data.is_admin === 0) {
                this.$router.push('/project-list');
              } else if (response.data.data.is_admin === 1) {
                this.$router.push('/project/compound-list/bar');
              }
            } else {
              this.$message.error(response.data.message);
              this.refreshCaptcha(); // 登录失败，刷新验证码
            }
          } catch (error) {
            console.error('登录失败:', error);
            this.$message.error('登录失败:' + error.message);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async refreshCaptcha() {
      try {
        const response = await axios.get('api/get-captcha');
        this.captchaSvg = response.data; // 存储 SVG 验证码
        // 假设后端在响应头中返回验证码的 key
        this.captchaKey = response.headers['captcha-key']; 
      } catch (error) {
        console.error('刷新验证码失败:', error);
        this.$message.error('刷新验证码失败:' + error.message);
      }
    }
  },
  mounted() {
    this.refreshCaptcha(); // 页面加载时初始化验证码
  }
};
</script>

<style scoped>

.login-container {
  background: url('../../src/assets/image/dist/img/log.png') no-repeat center center;
  background-size: cover;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'FZQingYue', 'Microsoft YaHei', sans-serif;
}

.login-box {
  width: 500px;
  height: 500px;
  background: url('../../src/assets/image/dist/img/log1.png') no-repeat center center;
  background-size: contain;
}

.login-form {
  margin-top: 30px;
  margin-left: 165px;
  
}

.page-title {
  font-size: 32px;
  color: #333;
  margin: 0 0 30px;
  text-align: center;
  margin-top: 50px;
}
.page-title1 {
  text-align: center;
  color: #333;
  font-size: 40px;
}
.captcha-wrapper {
  display: flex;
  width: 300px;            /* 总宽度固定 */
  height: 38px;            /* 与输入框高度一致 */
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.captcha-input {
  flex: 1;
  border: none;
}

.captcha-input .el-input__inner {
  border: none !important;
  height: 100%;
  box-shadow: none;
  padding-left: 10px;
}

.captcha-image {
  width: 90px;             /* 验证码图片宽度 */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-left: 1px solid #dcdfe6;
  background: #f9f9f9;
}

.login-button {
  width: 230px;
  height: 50px;
  /* line-height: 40px;
  border-radius: 4px;
  font-size: 16px; */
  background-color: #355e3b ;
  border-color: #355e3b;
  /* margin-top: 30px; */
  /* display: block;
  margin: 0 auto; */
}

.login-button:hover {
  background-color: #355e3b;
  border-color: #355e3b;
}

.login-button:active {
  background-color: #355e3b;
  border-color: #355e3b;
}

.form-footer {
  text-align: center;
  /* margin-top: 50px; */
}

.footer-link {
  color:#355e3b;
  text-decoration: none;
  font-size: 14px;
}

 .divider {
  color: white;
  margin: 0 10px;
}

:deep(.el-form-item) {
  /* background-color: black; */
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  width: 50%; 
} 

:deep(.el-input__inner) {
  background-color: #ffffff !important;
  border-color: #dcdfe6 !important;
  box-shadow: none !important;
  height: 40px!important;
  width: 300px!important;
  margin-top: 20px;
}

::v-deep(.el-input__inner:focus) {
  background-color: #ffffff !important;
  border-color: #dcdfe6; 
  box-shadow: none !important;
}

</style>